import { z } from 'zod';

// Validation error messages by locale
const validationMessages = {
  en: {
    name: {
      min: 'Name must be at least 2 characters',
      max: 'Name must be less than 100 characters',
      regex: 'Name can only contain letters'
    },
    email: {
      invalid: 'Please enter a valid email address',
      max: 'Email must be less than 255 characters'
    },
    phone: {
      min: 'Phone number must be at least 10 digits',
      max: 'Phone number must be less than 20 digits',
      regex: 'Please enter a valid phone number'
    },
    subject: {
      min: 'Subject must be at least 3 characters',
      max: 'Subject must be less than 200 characters'
    },
    service: {
      min: 'Service must be at least 2 characters',
      max: 'Service must be less than 100 characters'
    },
    message: {
      min: 'Message must be at least 10 characters',
      max: 'Message must be less than 2000 characters'
    }
  },
  ar: {
    name: {
      min: 'يجب أن يتكون الاسم من حرفين على الأقل',
      max: 'يجب أن يكون الاسم أقل من 100 حرف',
      regex: 'يمكن أن يحتوي الاسم على أحرف فقط'
    },
    email: {
      invalid: 'يرجى إدخال عنوان بريد إلكتروني صالح',
      max: 'يجب أن يكون البريد الإلكتروني أقل من 255 حرفاً'
    },
    phone: {
      min: 'يجب أن يتكون رقم الهاتف من 10 أرقام على الأقل',
      max: 'يجب أن يكون رقم الهاتف أقل من 20 رقماً',
      regex: 'يرجى إدخال رقم هاتف صالح'
    },
    subject: {
      min: 'يجب أن يتكون الموضوع من 3 أحرف على الأقل',
      max: 'يجب أن يكون الموضوع أقل من 200 حرف'
    },
    service: {
      min: 'يجب أن تتكون الخدمة من حرفين على الأقل',
      max: 'يجب أن تكون الخدمة أقل من 100 حرف'
    },
    message: {
      min: 'يجب أن تتكون الرسالة من 10 أحرف على الأقل',
      max: 'يجب أن تكون الرسالة أقل من 2000 حرف'
    }
  },
  fr: {
    name: {
      min: 'Le nom doit contenir au moins 2 caractères',
      max: 'Le nom doit contenir moins de 100 caractères',
      regex: 'Le nom ne peut contenir que des lettres'
    },
    email: {
      invalid: 'Veuillez entrer une adresse e-mail valide',
      max: "L'e-mail doit contenir moins de 255 caractères"
    },
    phone: {
      min: 'Le numéro de téléphone doit contenir au moins 10 chiffres',
      max: 'Le numéro de téléphone doit contenir moins de 20 chiffres',
      regex: 'Veuillez entrer un numéro de téléphone valide'
    },
    subject: {
      min: 'Le sujet doit contenir au moins 3 caractères',
      max: 'Le sujet doit contenir moins de 200 caractères'
    },
    service: {
      min: 'Le service doit contenir au moins 2 caractères',
      max: 'Le service doit contenir moins de 100 caractères'
    },
    message: {
      min: 'Le message doit contenir au moins 10 caractères',
      max: 'Le message doit contenir moins de 2000 caractères'
    }
  }
};

// Function to get validation schema with translated messages
export const getContactFormSchema = (locale: string = 'en') => {
  const messages = validationMessages[locale as keyof typeof validationMessages] || validationMessages.en;

  return z.object({
    name: z
      .string()
      .min(2, messages.name.min)
      .max(100, messages.name.max)
      .regex(/^[a-zA-Z\s\u0600-\u06FF\u0750-\u077F\u00C0-\u00FF]+$/, messages.name.regex),
    
    email: z
      .string()
      .email(messages.email.invalid)
      .max(255, messages.email.max),
    
    phone: z
      .string()
      .min(10, messages.phone.min)
      .max(20, messages.phone.max)
      .regex(/^[0-9+\-\s()]+$/, messages.phone.regex),
    
    subject: z
      .string()
      .min(3, messages.subject.min)
      .max(200, messages.subject.max),
    

    
    message: z
      .string()
      .min(10, messages.message.min)
      .max(2000, messages.message.max),
    
    locale: z
      .string()
      .default(locale)
  });
};

// Default schema (English)
export const contactFormSchema = getContactFormSchema('en');

export type ContactFormData = z.infer<typeof contactFormSchema>;

